// eslint-disable-next-line jsdoc/require-jsdoc
export function sourceItemToExtendedSourceItem(entry, alternativeBaseURL) {
    let baseURL = entry.baseURL || alternativeBaseURL;
    if (!baseURL) {
        if (!globalThis.location?.href) {
            throw new Error(`We could not find a baseURL for ${entry.relativePath}`);
        }
        else {
            baseURL = globalThis.location.href;
        }
    }
    const fileURL = new URL(entry.relativePath, baseURL);
    const source = {
        uuid: crypto.randomUUID(),
        name: entry.relativePath.split('/').pop() || '',
        size: entry.size,
        baseURL,
        relativePath: entry.relativePath,
        lastModified: entry.lastModified,
        text: async () => {
            const response = await fetch(fileURL.toString());
            return response.text();
        },
        arrayBuffer: async () => {
            const response = await fetch(fileURL.toString());
            return response.arrayBuffer();
        },
        stream: () => {
            const { writable, readable } = new TransformStream();
            async function propagateErrorToStream(error) {
                await Promise.allSettled([
                    writable.abort(error),
                    readable.cancel(error),
                ]);
            }
            async function pipeFetchToStream() {
                const response = await fetch(fileURL.toString());
                // Should not be null
                const body = response.body;
                await body.pipeTo(writable);
            }
            void pipeFetchToStream().catch(propagateErrorToStream);
            return readable;
        },
    };
    return source;
}
//# sourceMappingURL=sourceItemToExtendedSourceItem.js.map